const RETRYABLE_REPORT_ERROR_CODES = new Set([
  "IDLE_TIMEOUT",
  "REPORT_QUERY_TIMEOUT",
  "WORKER_RESOURCE_LIMIT",
]);

/**
 * Whether a non-OK reports POST response should be retried with backoff
 * (same semantics as useProgressiveReports postReports).
 */
export function isRetryableReportsPostResponse(status: number, json: unknown): boolean {
  if (status === 503 || status === 504) return true;
  if (json && typeof json === "object" && "code" in json) {
    const code = (json as { code?: unknown }).code;
    if (typeof code === "string" && RETRYABLE_REPORT_ERROR_CODES.has(code)) {
      return true;
    }
  }
  return false;
}
